'use strict';

const flatpickr = require('flatpickr');

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.warranty-signup-message').length === 0) {
        $('body').append(
            '<div class="warranty-signup-message"></div>'
        );
    }
    $('.warranty-signup-message')
        .append('<div class="warranty-signup-alert text-center ' + status + '" role="alert">' + data.msg + '</div>');

    setTimeout(function () {
        $('.warranty-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}


module.exports = {
    submitWarranty: function () {
        $('textarea').keyup(function () {
            var $errorDiv = $(this).next('.invalid-feedback');
            if ($(this).val().length <= 0) {
                $(this).addClass('is-invalid');
                $errorDiv.show();
            } else {
                $errorDiv.hide();
                $(this).removeClass('is-invalid');
            }
        });
        $('input[type=file]').on('change', function () {
            $(this).blur();
        });

        $('form.warranty').submit(function (e) {
            e.preventDefault();

            var form = $(this);
            var button = $('.btn-send-warranty');
            var url = form.attr('action');

            $.spinner().start();
            button.attr('disabled', true);
            if (grecaptcha) {
                grecaptcha.ready(function () {
                    grecaptcha.execute(window.app.preferences.reCaptchaSiteKey, { action: 'submit' }).then(function (token) {
                        form.append("<input type='hidden' name='dwfrm_warranty_lenstypejoined' value='" + $('#dwfrm_warranty_lenstype').val().join(';') + "'/>");
                        form.append("<input type='hidden' name='dwfrm_warranty_reCaptchaToken' value='" + token + "'/>");
                        var payload = new FormData(form[0]);
                        $.ajax({
                            url: url,
                            type: 'post',
                            enctype: 'multipart/form-data',
                            dataType: 'json',
                            data: payload,
                            processData: false,
                            contentType: false,
                            cache: false,
                            timeout: 60000,
                            success: function (data) {
                                $.spinner().stop();
                                if (data.success) {
                                    $('.warranty').trigger('reset');
                                    window.location.href = data.redirectUrl;
                                } else {
                                    displayMessage(data, button);
                                }
                            },
                            error: function (err) {
                                displayMessage(err, button);
                                $.spinner().stop();
                            }
                        });
                    });
                });
            }
        });
    },
    updateState: function () {
        $('#dwfrm_warranty_country').on('change', function () {
            if ($(this).val() === 'US') {
                $('.us-states').addClass('default');
                $('.ca-states').removeClass('default');
            } else if ($(this).val() === 'CA') {
                $('.ca-states').addClass('default');
                $('.us-states').removeClass('default');
            }
        });
    },
    enableDatePicker: function () {
        $('.flatpickr').flatpickr({
            dateFormat: window.app.preferences.datePickerFormat,
            wrap: true,
            disableMobile: 'true',
            onClose: function (selectedDates, dateStr) {
                if (dateStr.length > 0) {
                    var $invalidFeedback = $('.flatpickr-input').parents('.form-group').find('.invalid-feedback');
                    $invalidFeedback.hide();
                    $('.flatpickr-input').removeClass('is-invalid');
                }
            }
        });
    }
};
